
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wooseuvfucxnbjdbzwnn.supabase.co';
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indvb3NldXZmdWN4bmJqZGJ6d25uIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzM4NjE0ODMsImV4cCI6MTk4OTQzNzQ4M30.4uhQNSZvOIi-5Y5IVvGROtLpCpA1VnTIpE-gmFGTpJI";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;